module.exports = __webpack_public_path__ + "img/pl_get.cbd355e.png";